module.exports = __webpack_public_path__ + "static/img/driblab_dark.4b1f78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_dark.png
// module id = 53V8
// module chunks = 94